export default {
  type: '', // speaker, slides, presentation, other
};
